<template>
    <div>
        <a @mouseover="over" @mouseout="out" @click="$emit('click', $event)" :href="href" :style="linkStyles">
            <slot>{{ contact.primary_display_as }}</slot>
            <ui-popover 
                ref="popover"
                class="custom-popover small arrow arrow-white-top" 
                open-on="manual" 
                position="bottom"
                :constrain-to-scroll-parent="false" 
                offset="0,10"
            >
                <div class="popover-inner">
                    <div style="padding: .5rem;">
                        <table class="table table-sm contact-details-popover-table" style="margin-bottom: none; table-layout: auto;">
                            <tr v-if="contact.primary_telephone">
                                <td>
                                    <span class="material-icons">phone</span>
                                </td>
                                <td>
                                    {{ contact.primary_telephone }}
                                </td>
                            </tr>
                            <tr v-if="contact.alternate_telephone">
                                <td>
                                    <span class="material-icons">phone</span>
                                </td>
                                <td>
                                    {{ contact.alternate_telephone }}
                                </td>
                            </tr>
                            <tr v-if="contact.email">
                                <td>
                                    <span class="material-icons">email</span>
                                </td>
                                <td>
                                    {{ contact.email }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </ui-popover>
        </a>
    </div>
</template>

<style lang="scss">
    .contact-details-popover-table {
        margin-bottom: 0;
        font-size: .9rem;
        tr:first-of-type td { border-top: none; }
        label { opacity: 0.5; display: block; }
        .material-icons { font-size: 1rem; vertical-align: middle; }
    }
</style>

<script>
    let delayTimer;

    export default {
        props: {
            contact: {
                type: Object,
                required: true
            },
            linkColour: {
                type: String,
                required: false,
                default: '',
            }
        },
        computed: {
            linkStyles() {
                if (this.linkColour.length > 0) {
                    return 'color: ' + this.linkColour
                }

                return ''
            },
            href() {
                return this.$root.buildUrl('contacts/%s', [this.contact.id])
            }
        },
        methods: {
            over() {
                delayTimer = setTimeout(() => { 
                    if (this.$refs.popover) {
                        this.$refs.popover.open() 
                    }
                }, 500)
            },
            out() {
                clearTimeout(delayTimer)

                if (this.$refs.popover) {
                    this.$refs.popover.close()
                }
            }
        }
    }
</script>